import $ from "jquery";

const toggleOther = function () {
  const $field = $(this);
  const $otherField = $("#" + $(this).attr("id") + "_other");
  const lastOptionSelected = $field.find("option:last-child").is(":selected");
  $otherField.prop("disabled", !lastOptionSelected);
};

$(document).on("turbolinks:load", function () {
  $("#customer_industry, #customer_job_profile").each(function (i, e) {
    $(e).on("change", toggleOther);
    toggleOther.call(e);
  });
});
